export const MARKETING_URL : string = 'https://troupe.com';
